import { render, staticRenderFns } from "./NoteSidebar.vue?vue&type=template&id=45dceea8&"
import script from "./NoteSidebar.vue?vue&type=script&lang=js&"
export * from "./NoteSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NoteSidebar.vue?vue&type=style&index=0&id=45dceea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports